export function isIE(ua = window.navigator.userAgent) {
  return ['MSIE', 'Trident'].some(s => ua.includes(s))
}

export function isAndroidChrome() {
  return ['Android', 'Chrome'].every(s => window.navigator.userAgent.includes(s))
}

export function applyIeClassName() {
  if (isIE()) document.body.classList.add('ie')
}

export function getCurrentUrl() {
  return process.browser && window.location.href
}

export function getQueryString() {
  return process.browser && window.location.search
    .substring(1)
    .split('&')
    .map(pair => pair.split('='))
    .reduce((table, [key, value]) => ({ ...table, [key]: value }), {})
}

/*
 * This function is included in case CookieBanner ever runs on the server
 * Would need to be changed if domain structure ever changes
 */
export function getDomain(host) {
  try {
    const lastTwoParts = (host || window.location.hostname)
      .split('.')
      .slice(-2)
      .join('.')

    return `.${lastTwoParts}`
  } catch (e) {
    return '.stv.tv'
  }
}

export function formatUrl(url) {
  if (!url.includes('https')) {
    // eslint-disable-next-line no-param-reassign
    url = url.replace('http', 'https')
  }

  if (url.charAt(url.length - 1) === '/') {
    return url.slice(0, -1)
  }
  return `${url}`
}
